import { render, staticRenderFns } from "./CustomColumn.vue?vue&type=template&id=b117c260&scoped=true&"
import script from "./CustomColumn.vue?vue&type=script&lang=js&"
export * from "./CustomColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117c260",
  null
  
)

export default component.exports